import { CircularProgress, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import { animated } from 'react-spring';
import { formatNumber } from '../../../../../logic/otherUtilities/formatting/formatNumber';

export interface PerformanceItemProps {
  label: string;
  number: any;
  numberSuffix?: string;
  numberLabel: string;
  share: number;
  icon: React.ComponentType<any>;
  description: string[];
  bgColor: string;
  labelColor: string;
}
export const useClasses = makeStyles<{}, { bgColor: string; labelColor: string }>({
  labelColor: {
    color: (props) => props.labelColor,
  },
  backgroundColor: {
    backgroundColor: (props) => props.bgColor,
  },
});

export const PerformanceItem: React.FC<PerformanceItemProps> = ({
  label,
  number,
  numberLabel,
  share,
  numberSuffix,
  icon,
  description,
  bgColor,
  labelColor,
}) => {
  const Icon = icon;
  const classes = useClasses({ bgColor, labelColor });
  return (
    <>
      <div
        className={`px-4 py-6 text-center rounded-md ${classes.labelColor} ${classes.backgroundColor}`}
      >
        <div className="py-4">
          <Typography variant="h5" display="block">
            {label}
          </Typography>
        </div>
        <div className="py-4 w-full">
          <div className="relative left-1/2">
            <CircularProgress
              size={120}
              value={share}
              thickness={3}
              variant="determinate"
              color="secondary"
              className={`z-10 absolute -left-[60px] top-0 ${classes.labelColor} `}
            />
            <CircularProgress
              size={120}
              value={100}
              thickness={3}
              variant="determinate"
              color="secondary"
              className={`opacity-40 z-[9] absolute -left-[60px] top-0 ${classes.labelColor} `}
            />
          </div>
        </div>
        <div className="py-6">
          <Icon fontSize="large" className="text-[48px]" />
        </div>
        <div className="pt-10 pb-2">
          <Typography variant={'h4'} noWrap>
            <animated.span>
              {number.to((val: number) => formatNumber(val, 0) + (numberSuffix ?? ''))}
            </animated.span>
          </Typography>
          <Typography noWrap variant={'subtitle1'}>
            {numberLabel}
          </Typography>
        </div>
      </div>
      <div className="py-4">
        {description.map((d, index) => (
          <Typography variant="subtitle1" align="center" key={index}>
            {d}
          </Typography>
        ))}
      </div>
    </>
  );
};

export default PerformanceItem;
